<template>
  <Component :is="mainComponent"/>
</template>

<script>
import { mapGetters } from 'vuex'
import MyAccountDefault from '@/views/MyAccountDefault'
import MyAccountInsights from '@/views/MyAccountInsights'

export default {
  name: 'MyAccount',

  components: {
    MyAccountDefault,
    MyAccountInsights
  },

  computed: {
    ...mapGetters('auth', ['userRole']),

    mainComponent () {
      return this.userRole === 'platform'
        ? 'MyAccountInsights'
        : 'MyAccountDefault'
    }
  }
}
</script>
